var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 44H44",
    stroke: "#076338",
    strokeWidth: 3,
    strokeLinecap: "butt",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26L12 28V38H4V26Z",
    fill: "#00b897",
    stroke: "#076338",
    strokeWidth: 3,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24L28 20V38H20V24Z",
    fill: "#00b897",
    stroke: "#076338",
    strokeWidth: 3,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16L44 12V38H36V16Z",
    fill: "#00b897",
    stroke: "#076338",
    strokeWidth: 3,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18L12 20L44 4H34",
    stroke: "#076338",
    strokeWidth: 3,
    strokeLinecap: "butt",
    strokeLinejoin: "bevel"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.41cbb0ce2728e19f7ca6860ba1369b99.svg";
export { ForwardRef as ReactComponent };